export const GameModes = {
  Real: 'real',
  Fun: 'fun',
};
